import { render } from "./ImgUpload.vue?vue&type=template&id=f545d6b6&scoped=true"
import script from "./ImgUpload.vue?vue&type=script&lang=js"
export * from "./ImgUpload.vue?vue&type=script&lang=js"

import "./ImgUpload.vue?vue&type=style&index=0&id=f545d6b6&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f545d6b6"]])

export default __exports__